import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { loginWithGoogle } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      const sessionId = searchParams.get('session_id');
      
      if (!sessionId) {
        setError('No session ID found');
        setTimeout(() => navigate('/auth'), 2000);
        return;
      }

      try {
        await loginWithGoogle(sessionId);
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Google auth error:', err);
        setError(err.message || 'Authentication failed');
        setTimeout(() => navigate('/auth'), 2000);
      }
    };

    handleCallback();
  }, [searchParams, loginWithGoogle, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <div className="text-red-400">
            <p className="text-lg mb-2">Error de autenticación</p>
            <p className="text-sm">{error}</p>
            <p className="text-xs mt-2 text-slate-500">Redirigiendo...</p>
          </div>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-amber-500 mx-auto mb-4" />
            <p className="text-white">Completando autenticación...</p>
          </>
        )}
      </div>
    </div>
  );
}
